import { Step } from 'react-joyride';
import { joyrideStep, joyrideWelcome } from '../../../shared/tours/sittJoyrideTheme';

export const OT_GENERAL_TOUR_KEY = 'ot-stepper-general';

export const otGeneralTourSteps: Step[] = [
    joyrideWelcome(
        'Orden de trabajo',
        'Este flujo guía la OT desde la cita en taller hasta la entrega. Avance paso a paso y registre notas en la bitácora cuando ocurra algo relevante.',
    ),
    joyrideStep(
        '#ot-stepper-header',
        'Encabezado',
        'Folio y tipo de OT. Use el botón de sincronizar para refrescar datos del servidor.',
        'bottom',
    ),
    joyrideStep(
        '#ot-stepper-tour-actions',
        'Guías interactivas',
        '«Guía del módulo» recorre la navegación. «¿Cómo funciona este paso?» explica cada campo del paso que tenga abierto.',
        'bottom',
    ),
    joyrideStep(
        '#ot-stepper-orden-compra-btn',
        'Orden de Compra (PDF)',
        'Tras la aprobación del coordinador, descargue aquí la OC con conceptos autorizados, datos del bien, taller y montos validados.',
        'bottom',
    ),
    joyrideStep(
        '#ot-stepper-nav',
        'Barra de pasos',
        'Los pasos completados se marcan en verde. Puede hacer clic en pasos ya visitados para revisarlos. Los bloqueados aún no están disponibles.',
        'bottom',
    ),
    joyrideStep(
        '#ot-stepper-bitacora',
        'Bitácora',
        'Registre comentarios de seguimiento (refacciones, retrasos, acuerdos). Quedan en el historial de la OT.',
        'top',
    ),
    joyrideStep(
        '#ot-stepper-advance-btn',
        'Avanzar',
        'Cuando termine el paso actual, pulse aquí para guardar y continuar. Si el paso ya estaba completo, solo avanza a la vista siguiente.',
        'top',
    ),
];

export const otStepTourSteps: Record<number, Step[]> = {
    1: [
        joyrideWelcome('Paso 1 — Agendar cita', 'Asigne el taller y la fecha/hora de la cita con el cliente.'),
        joyrideStep(
            '#ot-step1-select-taller',
            'Seleccionar taller',
            'Elija entre talleres recientes, cercanos o busque otro proveedor. Si no aparece en lista, use «Otro taller (Búsqueda)».',
        ),
        joyrideStep(
            '#ot-step1-busqueda-taller',
            'Búsqueda de taller',
            'Escriba al menos 3 caracteres del nombre del proveedor y seleccione el resultado correcto.',
        ),
        joyrideStep(
            '#ot-step1-fecha-cita',
            'Fecha de cita',
            'Indique cuándo debe presentarse el vehículo en el taller.',
        ),
        joyrideStep(
            '#ot-step1-requerimiento',
            'Requerimiento (opcional)',
            'Adjunte PDF o imagen con instrucciones previas para el taller, si las tiene.',
        ),
    ],
    2: [
        joyrideWelcome('Paso 2 — Ingreso', 'Confirme la llegada del vehículo y genere el pase para el cliente.'),
        joyrideStep(
            '#ot-step2-fecha-ingreso',
            'Fecha de ingreso real',
            'Capture la fecha y hora en que el vehículo ingresó físicamente al taller.',
        ),
        joyrideStep(
            '#ot-step2-evidencia-ingreso',
            'Evidencia de ingreso',
            'Suba fotos, video o PDF del inventario inicial y estado del vehículo al recibirlo.',
        ),
        joyrideStep(
            '#ot-step2-voucher-section',
            'Pase para WhatsApp',
            'Genere una imagen con datos del taller, vehículo y cita para compartir con el cliente.',
        ),
        joyrideStep(
            '#ot-step2-voucher-ticket',
            'Vista previa del pase',
            'Revise que taller, vehículo y fecha sean correctos antes de descargar.',
        ),
        joyrideStep(
            '#ot-step2-voucher-destino',
            'Destino',
            'Nombre del proveedor y sucursal donde debe presentarse el cliente.',
        ),
        joyrideStep(
            '#ot-step2-voucher-vehiculo',
            'Vehículo',
            'Marca, modelo, año y número de serie del bien en servicio.',
        ),
        joyrideStep(
            '#ot-step2-voucher-cita',
            'Cita programada',
            'Fecha y hora acordada en el paso anterior.',
        ),
        joyrideStep(
            '#ot-step2-voucher-qr',
            'Código QR',
            'Al escanearlo, el cliente abre la ubicación del taller en Google Maps.',
        ),
        joyrideStep(
            '#ot-step2-voucher-descargar',
            'Descargar pase',
            'Guarde la imagen y envíela por WhatsApp u otro medio al conductor o contacto del cliente.',
        ),
    ],
    3: [
        joyrideWelcome('Paso 3 — Diagnóstico', 'Registre la cotización del taller y el desglose de conceptos.'),
        joyrideStep(
            '#ot-step3-fecha-entrega',
            'Fecha estimada de entrega',
            'Fecha que el taller compromete para terminar el trabajo.',
        ),
        joyrideStep(
            '#ot-step3-cotizacion',
            'PDF de cotización',
            'Suba el documento de cotización oficial del taller. Es obligatorio para avanzar.',
        ),
        joyrideStep(
            '#ot-step3-conceptos',
            'Desglose de conceptos',
            'Capture cada partida: categoría, cantidades, precios e impuestos. Use «Añadir Concepto» si faltan líneas.',
        ),
    ],
    4: [
        joyrideWelcome('Paso 4 — Evidencias de reparación', 'Adjunte fotos o videos por cada concepto autorizado.'),
        joyrideStep(
            '#ot-step4-evidencias',
            'Evidencias por concepto',
            'Cada partida del diagnóstico debe tener evidencia visual del trabajo realizado, salvo que marque omisión cuando no aplique.',
        ),
    ],
    5: [
        joyrideWelcome('Paso 5 — VoBo del cliente', 'Valide la aprobación del cliente sobre la cotización y reparación.'),
        joyrideStep(
            '#ot-step5-orden-compra',
            'Orden de Compra',
            'Descargue el PDF con los conceptos aprobados por el coordinador, monto autorizado y datos del taller.',
        ),
        joyrideStep(
            '#ot-step5-resumen',
            'Resumen y VoBo',
            'Revise montos y evidencias. Suba el documento de visto bueno del cliente o rechace devolviendo la OT al ejecutivo con motivo.',
        ),
    ],
    6: [
        joyrideWelcome('Paso 6 — Aprobación administrativa', 'Contraloría valida montos, impuestos y documentación.'),
        joyrideStep(
            '#ot-step6-orden-compra',
            'Orden de Compra',
            'La OC generada tras la aprobación del coordinador está disponible para descarga en cualquier momento.',
        ),
        joyrideStep(
            '#ot-step6-aprobacion',
            'Validación administrativa',
            'Confirme o rechace conceptos según políticas internas. Los rechazos regresan la OT al ejecutivo.',
        ),
    ],
    8: [
        joyrideWelcome('Paso 8 — Pago', 'Gestione comprobante de pago al proveedor cuando aplique pago inmediato.'),
        joyrideStep(
            '#ot-step8-pago',
            'Comprobante de pago',
            'Adjunte transferencia o comprobante emitido. Si el proveedor es a crédito, este paso puede quedar informativo.',
        ),
    ],
    9: [
        joyrideWelcome('Paso 9 — Entrega', 'Cierre la OT con entrega al cliente y evaluación del taller.'),
        joyrideStep(
            '#ot-step9-fechas',
            'Fechas de entrega',
            'Registre cuándo terminó el taller y cuándo se entregó el vehículo al cliente.',
        ),
        joyrideStep(
            '#ot-step9-evidencias',
            'Evidencia de entrega',
            'Fotos o documentos que acrediten la entrega del vehículo.',
        ),
        joyrideStep(
            '#ot-step9-evaluacion',
            'Evaluación del taller',
            'Califique la experiencia en diagnóstico, puntualidad, comunicación y facturación.',
        ),
    ],
};

export function getOtStepTourSteps(activeStep: number): Step[] {
    return otStepTourSteps[activeStep] ?? [];
}
